import { ArrowPathIcon, CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/solid'
import { ChevronDownIcon, ChevronRightIcon } from '@heroicons/react/24/outline'
import { useEffect, useState } from 'react'

export default function TextField({
  id,
  value,
  type,
  label,
  autoComplete,
  isFocused,
  variant,
  inputRef,
  placeholderText,
  required,
  helpText,
  error,
  onChange,
  showProgress = false,
  showCompleted = false,
  showError = false,
  readOnly = false,
  collapsible = false,
  defaultExpanded = false,
}) {
  const [expanded, setExpanded] = useState(() => {
    if (defaultExpanded) return true
    // Treat "" / null / undefined / "0" / 0 as empty so collapsible fields default collapsed.
    if (value === "" || value == null || value === "0" || value === 0) return false
    return true
  })

  useEffect(() => {
    if (isFocused && expanded) {
      inputRef?.current?.focus()
    }
  }, [isFocused, inputRef, expanded])

  const renderLabel = () => {
    if (!label) return null
    if (collapsible) {
      return (
        <button
          type="button"
          onClick={() => setExpanded((v) => !v)}
          className="flex items-center gap-1 mb-2 text-sm font-medium text-text_secondary hover:text-text transition-colors w-fit"
        >
          {expanded ? <ChevronDownIcon className="w-4 h-4" /> : <ChevronRightIcon className="w-4 h-4" />}
          {label}
        </button>
      )
    }
    return (
      <label htmlFor={id} className="block mb-2 text-sm font-medium text-text_secondary">
        {label}
      </label>
    )
  }

  return (
    <div className="relative">
      <div className="absolute right-[10px] top-[36px]">
        {showProgress && (
          <ArrowPathIcon className="w-6 h-6 text-primary animate-spin" />
        )}
        {showCompleted && <CheckCircleIcon className="w-6 h-6 text-success" />}
        {showError && <XCircleIcon className="w-6 h-6 text-error" />}
      </div>
      {renderLabel()}
      {(!collapsible || expanded) && (
        <input
          id={id}
          value={value}
          autoComplete={autoComplete}
          autoFocus={isFocused}
          type={type ?? 'text'}
          placeholder={placeholderText}
          required={required}
          className="bg-neutral_2 text-decoration-none border border-bordered text-text text-sm rounded-lg focus:ring-primary focus:border-primary block w-full p-2.5 outline-none border-transparent focus:border-transparent focus:ring-0"
          onChange={(e) => onChange(e.target.value)}
          ref={inputRef}
          readOnly={readOnly}
        />
      )}
      {error && <p className="text-error text-sm mt-2">{error}</p>}
    </div>
  )
}
